/** Presentation must fail closed until the live resource access summary allows reading. */
export type ConversationAuthorizationView = 'loading' | 'unavailable' | 'content';

export function conversationAuthorizationView(
  accessLoading: boolean,
  authorizationReady: boolean
): ConversationAuthorizationView {
  if (accessLoading) {
    return 'loading';
  }
  return authorizationReady ? 'content' : 'unavailable';
}
